<div class="website-content" style="max-width:72rem;padding:0 var(--wa-spacing-x-large) var(--wa-spacing-x-large) var(--wa-spacing-x-large);">
	<div class="wa-stack wa-gap-xl">
		<div class="wa-stack wa-gap-m content-section">
			<wa-divider class="section-divider"></wa-divider>
			<div class="wa-stack wa-gap-s">
				<div class="hero-eyebrow" waCaption="s" waFontWeight="semibold" waText>STACK</div>
				<h2 waHeading="l" waText>Four-Layer Architecture</h2>
				<p waBody="m" waColorText="quiet" waText>Your app &rarr; Plugins &rarr; JWebMP Core &rarr; GuicedEE Foundation.</p>
			</div>
			<div class="wa-stack wa-gap-m">
				<p waBody="m" waText>The JWebMP stack is four layers deep. Your application sits at the top; everything below is framework infrastructure.</p>
				<div class="mermaid-diagram-wrapper">
					<div class="mermaid-diagram-label" waCaption="s" waFontWeight="semibold" waText>The JWebMP Stack</div>
					<div class="mermaid-diagram">
						<markdown [data]="mdContent_32" mermaid></markdown>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>